export const en = {
  comingSoon: 'Coming Soon',
  learnMore: 'Learn More',
  upgradeToLearnMore: 'Upgrade to learn more',
}

export const es = en
